<template>
  <span
    @click="resendActiveEmail"
    class="color pointer"
    v-ui-loading="mailSending"
  >
    {{ resendText }}
  </span>
</template>
<script>
import api from "../api/index";
export default {
  data() {
    return {
      mailSending: null
    };
  },
  props: ["email"],
  methods: {
    resendActiveEmail: function() {
      this.mailSending = { color: "light" };
      api
        .resendActiveEmail({ email: this.email })
        .then(res => {
          this.mailSending = null;
          this.$UiToast({
            message: this.$t("activeEmailSendSuccess")
          });
        })
        .catch(error => {
          this.mailSending = null;
          if (error.response.data.err == "alreadyActived") {
            this.$UiToast({
              message: this.$t("alreadyActived")
            });
            setTimeout(() => {
              this.$router.push("/login");
            }, 1000);
          }
          if (error.response.data.err == "emailNotFound") {
            this.$UiToast({
              message: this.$t("emailNotFound")
            });
            setTimeout(() => {
              this.$router.push("/reg");
            }, 1000);
          }
          if (error.response.data.err == "mailSendFailed") {
            this.$UiToast({
              message: this.$t("mailSendFailed"),
              type: "warning"
            });
          }
        });
    }
  },
  computed: {
    resendText() {
      return this.mailSending
        ? this.$t("activeEmail") + this.$t("emailSending")
        : this.$t("clickHere") +
            this.$t("resendEmail") +
            this.$t("activeEmail");
    }
  }
};
</script>
